export const DRIVER_STATEMENTS_TEXTS = {
	DRIVER_STATEMENTS: 'Drivers statements',
	CREATE_STATEMENTS: 'Create statements',
};
